import { LAYOUTS } from '@voltmoney/types';
import { ROUTE } from "../../routes";
import { WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { noAction, yesAction } from "./actions";
export const template = async () => {
    return {
        layout: {
            id: ROUTE.LOGOUT_SCREEN,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                { id: "logout", type: WIDGET.LOGOUT_SCREEN }
            ],
        },
        datastore: {
            logout: {
                yesAction: {
                    type: ACTION.YES_ACTION,
                    routeId: ROUTE.LOGOUT_SCREEN,
                    payload: {}
                },
                noAction: {
                    type: ACTION.NO_ACTION,
                    routeId: ROUTE.LOGOUT_SCREEN,
                    payload: {}
                },
            }
        },
    };
};
export const logoutMf = {
    onLoad: async () => {
        return Promise.resolve(template());
    },
    actions: {
        [ACTION.YES_ACTION]: yesAction,
        [ACTION.NO_ACTION]: noAction
    },
    clearPrevious: true,
};
